module.exports = __webpack_public_path__ + "img/DecisionFor.a89d001b.png";